module.exports = __webpack_public_path__ + "static/media/tasklist@2x.680e213e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/tasklist@2x.png
// module id = 737
// module chunks = 0